"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnFormateDays = exports.SECONDS_IN_A_DAY = exports.EnFormateDate = exports.secToTime = exports.formatUnixTime = exports.getMaxDayOfMonth = exports.getUnixTime = exports.compareTimeWithUTC8 = exports.getTimeUTC = exports.getZoneTime = exports.showTime = exports.formatTime = exports.milliseconds2HHMMSS = exports.getHourTimeWithSpan = exports.checkCurrentTimeInRangeDatetime = exports.checkCurrentTimeInRangeDate = exports.padStart = exports.getTodayEndUnixTime = exports.formatDate = void 0;
function formatDate(date) {
    var year = ("" + date).slice(0, 4);
    var month = ("" + date).slice(4, 6);
    var day = ("" + date).slice(6);
    return parseInt(day, 10) + "/" + parseInt(month, 10) + "/" + parseInt(year, 10);
}
exports.formatDate = formatDate;
function getTodayEndUnixTime() {
    var t = new Date();
    return new Date(t.getFullYear(), t.getMonth(), t.getDate(), 23, 59, 59).getTime() / 1000;
}
exports.getTodayEndUnixTime = getTodayEndUnixTime;
function datetime2Timestamp(datetime) {
    return new Date(datetime).getTime();
}
function padStart(num, len, ch) {
    if (len === void 0) { len = 2; }
    if (ch === void 0) { ch = "0"; }
    var output = "" + num;
    while (output.length < len) {
        output = "" + ch + output;
    }
    return output;
}
exports.padStart = padStart;
function checkCurrentTimeInRangeDate(start, end) {
    var now = new Date().getTime();
    var startTimestamp = datetime2Timestamp(start + " 00:00");
    var endTimestamp = datetime2Timestamp(end + " 23:59");
    return now >= startTimestamp && now <= endTimestamp;
}
exports.checkCurrentTimeInRangeDate = checkCurrentTimeInRangeDate;
function checkCurrentTimeInRangeDatetime(start, end) {
    if (!start || !end) {
        return false;
    }
    var now = new Date().getTime() / 1000;
    return now >= start && now <= end;
}
exports.checkCurrentTimeInRangeDatetime = checkCurrentTimeInRangeDatetime;
function getHourTimeWithSpan(spanTime, withSeconds) {
    if (withSeconds === void 0) { withSeconds = false; }
    var time = new Date(new Date().getTime() + spanTime);
    var hh = padStart(time.getHours());
    var mm = padStart(time.getMinutes());
    var ss = padStart(time.getSeconds());
    if (withSeconds) {
        return hh + ":" + mm + ":" + ss;
    }
    return hh + ":" + mm;
}
exports.getHourTimeWithSpan = getHourTimeWithSpan;
function milliseconds2HHMMSS(milliseconds) {
    return new Date(milliseconds).toISOString().substr(11, 8);
}
exports.milliseconds2HHMMSS = milliseconds2HHMMSS;
function formatTime(time, formatStr) {
    if (formatStr === void 0) { formatStr = "YYYY-MM-DD"; }
    var d = new Date(time);
    return formatStr
        .replace("YYYY", d.getFullYear().toString())
        .replace("MM", padStart(d.getMonth() + 1))
        .replace("DD", padStart(d.getDate()))
        .replace("HH", padStart(d.getHours()))
        .replace("mm", padStart(d.getMinutes()))
        .replace("ss", padStart(d.getSeconds()));
}
exports.formatTime = formatTime;
function showTime(time, haveHms) {
    if (haveHms === void 0) { haveHms = true; }
    return formatTime(time, haveHms ? "DD/MM/YYYY HH:mm:ss" : "DD/MM/YYYY");
}
exports.showTime = showTime;
function getZoneTime(zone) {
    return getTimeUTC() + zone * 60 * 60 * 1000;
}
exports.getZoneTime = getZoneTime;
function getTimeUTC() {
    var d = new Date();
    return d.getTime() + d.getTimezoneOffset() * 60 * 1000;
}
exports.getTimeUTC = getTimeUTC;
function compareTimeWithUTC8(time) {
    var localDatetime = new Date().getTime() / 1000;
    return localDatetime >= time;
}
exports.compareTimeWithUTC8 = compareTimeWithUTC8;
function getUnixTime(date, time) {
    var reg = new RegExp(/^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/);
    var result = reg.exec(date);
    if (result) {
        return (new Date(result[3] + "/" + result[2] + "/" + result[1] + " " + time).getTime() / 1000).toFixed(0);
    }
    else {
        return "";
    }
}
exports.getUnixTime = getUnixTime;
function getMaxDayOfMonth(year, month) {
    var date = new Date(year, month + 1, 1, 0, 0, 0).getTime();
    return new Date(date - 1000).getDate();
}
exports.getMaxDayOfMonth = getMaxDayOfMonth;
exports.formatUnixTime = function (time, formatStr) {
    if (formatStr === void 0) { formatStr = "YYYY-MM-DD HH:mm"; }
    return formatTime(parseInt(time, 10), formatStr);
};
exports.secToTime = function (sec) {
    var result = "";
    if (sec > -1) {
        var hour = Math.floor(sec / 3600);
        var min = Math.floor(sec / 60) % 60;
        var s = sec % 60;
        if (hour < 10) {
            result += "0";
        }
        result += hour + ":";
        if (min < 10) {
            result += "0";
        }
        result += min + ":";
        if (s < 10) {
            result += "0";
        }
        result += s;
    }
    return result;
};
exports.EnFormateDate = function (sec) {
    var date = new Date(sec);
    var monthArr = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    var year = date.getFullYear();
    var month = monthArr[date.getMonth()];
    var day = date.getDate().toString();
    return day + " " + month + " " + year;
};
exports.SECONDS_IN_A_DAY = 24 * 60 * 60;
exports.EnFormateDays = function (sec) {
    if (sec && sec > 0) {
        return Math.floor(sec / exports.SECONDS_IN_A_DAY);
    }
    else {
        return 0;
    }
};
